import TopNav from "./components/TopNav";
import Hero from "./components/Hero";
import HowItWorks from "./components/HowItWorks";
import FormatGuide from "./components/FormatGuide";
import Channels from "./components/Channels";
import Trending from "./components/Trending";
import Trust from "./components/Trust";
import SubmitForm from "./components/SubmitForm";
import Faq from "./components/Faq";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <>
      <TopNav />
      <main>
        <Hero />
        <HowItWorks />
        <FormatGuide />
        <Channels />
        <Trending />
        <Trust />
        <SubmitForm />
        <Faq />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}